module.exports = __webpack_public_path__ + "img/sentra10.faceb065.jpeg";